// extracted by mini-css-extract-plugin
export default {"container":"send-template_container__KegEu","greenButton":"send-template_greenButton__GyyEv"};